import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalFooterProps,
  ModalHeader,
  ModalHeaderProps,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/modal'
import { ModalBodyProps } from '@chakra-ui/react'
import React from 'react'

interface IProps extends ModalProps {
  header?: React.ReactNode
  headerProps?: Omit<ModalHeaderProps, 'children'>
  contentProps?: ModalContentProps
  footer?: React.ReactNode
  footerProps?: ModalFooterProps
  bodyProps?: ModalBodyProps
  closeBtn?: boolean
}

function ChakraModal(props: IProps) {
  const {
    closeBtn = true,
    bodyProps = {},
    headerProps = {},
    contentProps = {},
    footerProps = {},
    children,
    header,
    footer,
    ...modalProps
  } = props
  return (
    <Modal {...modalProps}>
      <ModalOverlay />
      <ModalContent {...contentProps}>
        {header && <ModalHeader {...headerProps}>{header}</ModalHeader>}
        {closeBtn && <ModalCloseButton />}
        <ModalBody {...bodyProps}>{children}</ModalBody>

        {footer && <ModalFooter {...footerProps}>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  )
}

export default ChakraModal
